import { render, staticRenderFns } from "./attribute-sets-listing.vue?vue&type=template&id=6dc8296c&scoped=true&"
import script from "./attribute-sets-listing.vue?vue&type=script&lang=js&"
export * from "./attribute-sets-listing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc8296c",
  null
  
)

export default component.exports